import React from "react";
import Navbar from "../components/site/Navbar";
import Footer from "../components/site/Footer";
import AccountSettings from "../components/AccountSettings";
import UpgradeCTA from "../components/UpgradeCTA";
import { Reveal } from "../components/site/Reveal";
import { useLang } from "../context/LanguageContext";

export default function Account() {
  const { t } = useLang();
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      <main data-testid="member-account" className="flex-1 pt-28 pb-20 max-w-7xl mx-auto px-5 md:px-8 w-full">
        <Reveal>
          <h1 className="font-display text-4xl md:text-5xl font-medium text-primary mb-1">{t("Account settings", "Paramètres du compte")}</h1>
          <p className="text-muted-foreground mb-8">{t("Manage your profile, photo and password.", "Gérez votre profil, votre photo et votre mot de passe.")}</p>
        </Reveal>
        <div className="mb-8"><UpgradeCTA variant="banner" /></div>
        <AccountSettings />
      </main>
      <Footer />
    </div>
  );
}
